
import React, {useEffect, useState} from 'react';
import BilderMartrix from "../BilderMartrix/BilderMartrix_"




function App(props) {  

   const [besetzung, setBesetzung] = useState(); 
     useEffect(() => {
        let url = "./configs/besetzung.json";
        fetch(url)
            .then(res => res.json())
            .then(json => setBesetzung(json))
        }, []);


    return (
      besetzung!=undefined?
      <div className="component-view animate" data-animate="blendin 3s">
         
         
         <div className="portrait-text-view" >
               <div className="text-item text-header">
               Leitung des Chores
              </div>
              <img className="image-view" src="./images/foto11_1024.png"/>
             
              <div className="text-item ">
              {besetzung.leader.name}
              </div>            
          </div>
         
         <div   className="flex-row-view">
         
        {
            besetzung.occupation.map((item) => {              
                return <BilderMartrix item={item}/>
            })
        }
      </div>

      

          
      </div>:null
            );
        }
    
    export default App;